import * as React from "react";
import { forwardRef } from "react";
const SvgArrowPointRightHeavy = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 3L17 12L8 21", stroke: "currentColor", strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgArrowPointRightHeavy);
export default ForwardRef;
